var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"board",attrs:{"title":_vm.tooltip}},[(_vm.boardType === 'message')?_c('div',{staticClass:"board-container picture-frame",style:({
      color: _vm.color,
      backgroundColor: _vm.backgroundColor,
      fontSize: _vm.fontSize + 'px',
      width: _vm.width + 'px',
      height: _vm.height + 'px',
      borderTopColor: _vm.borderColor,
      borderRightColor: _vm.borderColor,
      borderBottomColor: _vm.borderBottomColor,
      borderLeftColor: _vm.borderBottomColor,
      alignItems: _vm.textAlignVertical,
    })},[_c('div',{staticClass:"content",style:({ textAlign: _vm.textAlignHorizontal })},[_vm._v(_vm._s(_vm.content))])]):_vm._e(),(_vm.boardType === 'fusen')?_c('div',{staticClass:"board-container",style:({
      color: _vm.color,
      backgroundColor: _vm.backgroundColor,
      fontSize: _vm.fontSize + 'px',
      width: _vm.width + 'px',
      height: _vm.height + 'px',
      alignItems: _vm.textAlignVertical,
    })},[_c('div',{staticClass:"content",style:({ textAlign: _vm.textAlignHorizontal })},[_vm._v(_vm._s(_vm.content))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }